module.exports = __webpack_public_path__ + "img/wanc.c7faec95.png";